import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { cn } from '@/lib/cn';

export const TooltipProvider = TooltipPrimitive.Provider;

export const TooltipContent = (props: React.ComponentPropsWithRef<typeof TooltipPrimitive.Content>) => {
  const { ref, className, sideOffset = 6, ...rest } = props;
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        ref={ref}
        sideOffset={sideOffset}
        className={cn(
          'z-50 overflow-hidden rounded-md border border-border-subtle bg-surface px-3 py-1.5 text-xs text-foreground shadow-lg',
          'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
          className,
        )}
        {...rest}
      />
    </TooltipPrimitive.Portal>
  );
};
TooltipContent.displayName = TooltipPrimitive.Content.displayName;
